import { createFileRoute } from "@tanstack/react-router";

type ProjectSearch = {
  action?: "publish";
};

export const Route = createFileRoute("/_layout/projects/$projectId")({
  validateSearch: (search: Record<string, unknown>): ProjectSearch => ({
    action: search.action === "publish" ? "publish" : undefined,
  }),
});
